import {
    LifecycleInputDocumentCreate,
    LifecycleOutputDocumentCreate,
    SaveLifecycleInputDocuments,
    SaveLifecycleOutputDocuments,
} from "server/models"
import { POST } from "client/store/utils"


export const SaveLifecyclePhaseInputDocuments = (
    phaseId: number,
    inputDocuments: LifecycleInputDocumentCreate[],
) => {
    const inputDocumentsData: SaveLifecycleInputDocuments = {
        phaseId,
        inputDocuments,
    }
    return POST(
        "/lifecycleInputDocument/save",
        JSON.stringify(inputDocumentsData),
    )
}

export const SaveLifecyclePhaseOutputDocuments = (
    phaseId: number,
    outputDocuments: LifecycleOutputDocumentCreate[],
) => {
    const outputDocumentsData: SaveLifecycleOutputDocuments = {
        phaseId,
        outputDocuments,
    }
    return POST(
        "/lifecycleOutputDocument/save",
        JSON.stringify(outputDocumentsData),
    )
}
